import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.3.3@antd/es/form/index.js
// module id = 586
// module chunks = 0